// extracted by mini-css-extract-plugin
export default {"container":"HaXnOY","content":"jo7Fg7","animate":"OFNa_D","slider":"PKbcus","item":"C9kzB8","prev":"mGvMO8","next":"W_lwxx"};